import { Component, computed, output, input, linkedSignal } from "@angular/core";

@Component({
    selector: "wk-pagination",
    templateUrl: "./pagination.component.html",
    styleUrl: "./pagination.component.scss",
    host: { class: "wk-pagination" },
})
export class PaginationComponent {
    public itemsCount = input<number>(0);
    public pageSize = input<number>(5);
    public currentPage = input<number>(1);
    public maxSize = input<number>(3);
    public firstLastButtons = input<boolean>(false);
    public nextPreviousButtons = input<boolean>(true);
    public small = input<boolean>(false);

    private _currentPage = linkedSignal<number>(this.currentPage);

    public readonly pageChange = output<number>();

    protected totalPages = computed<number[]>(() => {
        return [...Array(Math.ceil(this.itemsCount() / this.pageSize())).keys()].map((i) => i + 1);
    });
    protected totalDisplayPages = computed<number[]>(() => {
        if (this.totalPages().length <= 4) {
            return [...Array(this.totalPages().length).keys()].map((i) => i + 1);
        } else {
            if (this.totalPages().length > this.currentPage() + 2) {
                if (this.currentPage() == 1 || this.currentPage() == 2) {
                    return [...Array(4).keys()].map((i) => i + 1);
                } else {
                    return [...Array(3).keys()].map((i) => i + this.currentPage() - 1);
                }
            } else {
                return [...Array(3).keys()].map((i) => i + this.totalPages().length - 2);
            }
        }
    });

    protected selectPageNumber(pageNumber: number) {
        this._currentPage.set(pageNumber);
        this.pageChange.emit(this._currentPage());
    }

    protected next() {
        const nextPage = this._currentPage() + 1;
        nextPage <= this.totalPages().length && this.selectPageNumber(nextPage);
    }

    protected previous() {
        const previousPage = this._currentPage() - 1;
        previousPage >= 1 && this.selectPageNumber(previousPage);
    }
}
